import {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";
import TextLabel from "../../controls/TextLabel/TextLabel.mjs";
import MyAccordion from "../../controls/MyAccordion/MyAccordion.mjs";
import "./CveLoadStatus.css";

const prefix = "CveLoadStatus";

const CveLoadStatus = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			l: Glob.getLanguageLong(),
			lang: Glob.getLanguage()
		};
		this.uid = Glob.generateUid(prefix);
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		Glob.register('Prefs', ()=>{
			this.setState({
				l: Glob.getLanguageLong(),
				lang: Glob.getLanguage()
			});
		}, this.uid);
		this.load();
	}
	componentWillUnmount() {
		Glob.unregister('Prefs', this.uid);
	}
	load() {
		appLib.api('cve/status').then( x => {
			const l = x?.list;
			if ( l && Array.isArray(l) && l.length ) {
				this.setState({
					tot: l.reduce((acc, cur) => (acc + cur.cve), 0),
					list: l
				});
			}
		}).catch( () => {
			appLib.api('cve/setup')
				.then( this.load )
				.catch( err => { console.log(err); } );
		});
	}
	render() {
		if ( ! this.state.list ) return null;
		return (
			<div className={prefix} id={this.uid}>
				<MyAccordion
					title={<><TextLabel value={"CVE"} />: { this.state.tot.toLocaleString(this.state.l) }</> }
				>
					<div>
						<table>
							<thead>
							<tr>
								<th>
									<TextLabel value={"Year"} />
								</th>
								<th>
									<TextLabel value={"CVE"} />
								</th>
								<th>
									<TextLabel value={"LastUpdate"} />
								</th>
							</tr>
							</thead>
							<tbody>
							{ this.state.list.map( x => (
								<tr key={x.year}>
									<td>
										{ x.year }
									</td>
									<td>
										{ x.cve.toLocaleString(this.state.l) }
									</td>
									<td>
										{ new Date(x.last_update).toLocaleDateString(this.state.l) }
									</td>
								</tr>
							) ) }
							</tbody>
						</table>
					</div>
				</MyAccordion>
			</div>
		)
	}
}

export default CveLoadStatus;
